<template>
  <div>
    <el-form ref="formData" :rules="rules" :model="formData" label-width="120px" size="small">
      <el-row :gutter="24">
        <el-col :span="24"> <el-form-item label="关联构件:" v-if="isShow" class="elForm"> 
          <el-button @click="addConstruc">关联构件</el-button>
          <span :title="checkedNodes" style="margin-left:10px">{{checkedNodes}}</span>
        </el-form-item> </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24"> 
          <el-form-item label="流程描述:" v-if="routerParams.status==null"> <span class="flowDescribe">{{ flowDescribe }}</span> </el-form-item> 
          <el-form-item label="流程描述:" v-else> <span class="flowDescribe">{{ formData.describe }}</span> </el-form-item> 
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="旁站类型:">
            <el-select v-model="formData.typeOfSideStation"  style="width: 100%" filterable  @change="typeChange" :disabled="openDia==1">
              <el-option v-for="item in dicList.pangzhanleixingDic" :key="item.value" :label="item.label" :value="item.label" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="标题:" prop="title">
            <el-input v-model.trim="formData.title"  maxlength="30" show-word-limit :readonly="openDia==1">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="责任方:">
            <el-select v-model="formData.responsibleParty"  style="width: 100%" clearable filterable :disabled="openDia==1">
              <el-option v-for="item in dicList.zerenfangDic" :key="item.id" :label="item.roleItemName" :value="item.roleItemName" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="责任人:" >
            <el-select v-model="formData.responsiblePerson"  style="width: 100%" clearable filterable :disabled="openDia==1">
              <el-option v-for="(item, index) in dicList.zerenpersonDic" :key="index" :label="item.userName" :value="item.userName" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="创建人:">
            <el-input v-model.trim="formData.approveUser"  readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="旁站类别:">
            <el-select v-model="formData.inspectionCategory"  style="width: 100%" clearable filterable :disabled="openDia==1">
              <el-option v-for="item in dicList.pangzhanleibieDic" :key="item.id" :label="item.label" :value="item.label" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="formData.typeOfSideStation=='申请旁站'">
          <el-form-item label="问题类别:">
            <el-select v-model="formData.problemCategory"  style="width: 100%" clearable filterable :disabled="openDia==1">
              <el-option v-for="item in dicList.wentileibieDic" :key="item.id" :label="item.label" :value="item.label" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="formData.typeOfSideStation=='申请旁站'">
          <el-form-item label="检查结果:">
            <el-select v-model="formData.inspectionResults"  style="width: 100%" clearable filterable :disabled="openDia==1">
              <el-option v-for="item in dicList.jianchajieguoDic" :key="item.id" :label="item.label" :value="item.label" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="旁站内容:" v-if="formData.typeOfSideStation=='发起旁站'">
            <el-input v-model.trim="formData.content" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea"
              style="width: 100%" maxlength="200" show-word-limit :readonly="openDia==1"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="申请描述:" v-if="formData.typeOfSideStation=='发起旁站'">
            <el-input v-model.trim="formData.rectorapplyDescribe" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea"
              style="width: 100%" maxlength="200" show-word-limit :readonly="openDia==1"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="问题描述:" v-if="formData.typeOfSideStation=='申请旁站'">
            <el-input v-model.trim="formData.content" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea"
              style="width: 100%" maxlength="200" show-word-limit :readonly="openDia==1"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="整改描述:" v-if="formData.typeOfSideStation=='申请旁站'">
            <el-input v-model.trim="formData.rectorapplyDescribe" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea"
              style="width: 100%" maxlength="200" show-word-limit :readonly="openDia==1"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="要求完成时间:"  v-if="routerParams.status==null">
            <el-date-picker v-model="formData.endDate" clearable size="mini" type="date"
              format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" style="line-height: 20px">
        <el-col :span="24">
          <el-form-item label="附件" v-if="openDia!=1">
            <el-button @click="uploadFolder" ><i class="el-icon-plus" style="margin-right:5px"></i>上传文件</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <uploader ref="uploader" v-if="openDia!=1"/>
    <construc-me ref="construcMe" @addHander="addHander"></construc-me>
  </div>
</template>

<script>
import uploader from '@/CommonDP/components/UploaderForPerFileDan/Uploader';
import quaMange from "@/xgzdService/quaMange-service"
import construcMe from "../construcMe.vue"
import { mapState } from 'vuex';
export default {
  props: {
    list: {
      type: Array,
      required: false,
    },
    openDia:{
      type: Number,
      required: false,
    },
  },
  components: { uploader ,construcMe},
  data() {
    return {
      icon: require('@/CommonDP/assets/doc/folder_icon.png'),
      rules: {
        title: [{ required: true, message: '请填写标题', trigger: 'blur' }],
        content: [{ required: true, message: '请填写内容', trigger: 'blur' }],
        checkedNodes: [{ required: true, message: '请先选择要关联的构件', trigger: 'blur' }],
      },
      loading: false,
      loading: false,
      messageObj: {},
      dicList: {zerenfangDic:[],pangzhanleibieDic:[],wentileibieDic:[],jianchajieguoDic:[],zerenpersonDic:[]},
      formData: { title: '' ,modelComponentRelaList:[]},
      pickerOptions: {
        //限制日期
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        },
      },
      checkedNodes:""
    };
  },
  watch: {
    "formData.responsibleParty"(val){
      if(val)this.getZerenPerson(val)
    }
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      routerParams: (state) => state.projectMg.routerParams,
      userInfo: (state) => state.user.userInfo,
    }),

    flowDescribe() {
      return decodeURI(this.routerParams.flowDescribe);
    },
    isShow() {
      if(this.$route.query.noquaFlow)return true
      return false
    },
    tableData() {
      return this.list || [];
    },
  },
  async created() {
    this.formData.approveUserName = this.userInfo.name;
    this.formData.title = this.userInfo.name + '发起' + this.routerParams.name;
    this.formData.approveUser = this.userInfo.name;
    await this.getDic();
  },
  methods: {
    typeChange(){
      this.$set(this.formData, 'problemCategory', '');
      this.$set(this.formData, 'inspectionResults', '');
      this.$set(this.formData, 'content', '');
      this.$set(this.formData, 'rectorapplyDescribe', '');
      this.$forceUpdate()
    },
    // 接口：用于获取表单数据
    getFormData() {
      if(this.routerParams.status==null)this.formData.describe=this.flowDescribe;
      return this.formData;
    },

    // 接口：设置表单数据
    setFormData(formData) {
      this.formData = formData;
    },

    // 接口：校验表单数据
    validateFormData() {
       const status=this.routerParams.status;//0为驳回不判断
      const modeId=this.$route.query.modelId//没有打开模型不判断
       if(!this.checkedNodes&&modeId&&status!="0"){
        this.$message.warning("请选关联构件");
        return
      }
      let flag = null;
      this.$refs.formData.validate((valid) => {
        if (valid) flag = true;
        else flag = false;
      });
      return flag;
    },

     async getDic() {
       const { prjId } =this.prjInfo;
      const res = await quaMange.qualityDic(prjId);
      this.dicList=res.data;
      if(res.data.pangzhanleixingDic&&res.data.pangzhanleixingDic.length>0){
        this.formData.typeOfSideStation=res.data.pangzhanleixingDic[0].label
      }
    },
    validate() {
      let flag = null;
      this.$refs.formData.validate((valid) => {
        if (valid) flag = true;
        else flag = false;
      });
      return flag;
    },
    uploadFolder() {
      this.$store.dispatch('LocalUploadFloderData', this.tableData);
      this.$store.dispatch('LocalUploadType', new Date().getTime());
    },
    getPerson(){
      this.$set(this.formData, 'responsiblePerson', '');
    },
    async getZerenPerson(val){
      const { prjInfo:{prjId},dicList:{zerenfangDic}} =this;
      const roleItemId=zerenfangDic.find((item)=>item.roleItemName==val)?.roleItemId;
      const {data} = await quaMange.getZeRenren(prjId,roleItemId);
      this.dicList.zerenpersonDic=data;
      this.$forceUpdate(); // 调用此函数方法
    },
    addConstruc(){
      this.$refs.construcMe.open()
    },
    addHander(data){
      this.formData.modelComponentRelaList=data;
      const list=this.$refs.construcMe.checkedNodes
      const array = list.map((item) => { return item.folderName});
      this.checkedNodes=array.map((item) => item).join("/");
    }
  },
};
</script>

<style lang="scss" scoped>
.tree {
  overflow: auto;
  height: 500px;
  max-height: 500px;
  width: 100%;
}
.treeitem {
  display: flex;
  align-items: center;
  user-select: none;
}
.activeShowBar {
  max-height: 300px;
  overflow-y: auto;
}
.img {
  margin-right: 6px;
  height: 16px;
  width: 18px;
  user-select: none;
}
.midd-content {
  line-height: 40px;
}
.flowDescribe{
  line-height: 30px;
}
.elForm{
  margin-bottom: 5px;
}
</style>
